import { render, staticRenderFns } from "./modalResultado.vue?vue&type=template&id=4ddbb18d"
import script from "./modalResultado.vue?vue&type=script&lang=ts"
export * from "./modalResultado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports